import { createFileRoute, redirect } from '@tanstack/react-router';
import { LoginPage } from '@/features/auth';
import { useAuthStore } from '@/features/auth/store';

export const Route = createFileRoute('/auth/login')({
  beforeLoad: async () => {
    const { isAuthenticated } = useAuthStore.getState();

    await useAuthStore.getState().actions.checkAuth();

    if (isAuthenticated) {
      throw redirect({ to: '/projects' });
    }
  },
  component: LoginPage,
});
